// CoursesCard.js
import React from "react";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import styles from "../Components/CSSFiles/CoursesCard.module.css"; // using new scoped styles
import { withTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";

class CoursesCard extends React.Component {
  state = {
    courses: [],
    loading: false,
    error: null,
  };

  componentDidMount() {
    // Initialize from store if available
    this.syncCoursesFromProps();
  }

  componentDidUpdate(prevProps) {
    // If Redux-provided courses changed, resync local state
    if (prevProps.coursesFromStore !== this.props.coursesFromStore) {
      this.syncCoursesFromProps();
    }
  }

  syncCoursesFromProps = () => {
    try {
      // Prefer the prop (already fetched by RightSidebar with limit 5)
      const fromProps =
        Array.isArray(this.props.coursesFromStore)
          ? this.props.coursesFromStore
          : Array.isArray(this.props.coursesFromStore?.data?.allcourses?.edges)
          ? this.props.coursesFromStore.data.allcourses.edges
          : Array.isArray(this.props.coursesFromStore?.data?.allcourses)
          ? this.props.coursesFromStore.data.allcourses
          : null;

      const rawArray = fromProps || [];

      const normalized = rawArray.map((c) => {
        if (c?.id && (c?.name || c?.thumbnail)) return c;
        if (c?.node && (c.node.id || c.node.name)) return c.node;
        return c;
      });

      const activeCourses = normalized.filter((c) => (c?.active === true && c?.public === true && c?.is_draft === false)).slice(0, 4);
      this.setState({ courses: activeCourses, loading: false, error: null });
    } catch (err) {
      console.error("CoursesCard sync error:", err);
      this.setState({ error: err?.message || "Failed to load courses", loading: false });
    }
  };

  handleView = (course) => {
    const id = course.id || course._id || "";
    if (id) this.props.history.push(`/course/view/${id}`);
    else this.props.history.push("/courses");
  };

  render() {
    const { courses, loading, error } = this.state;
    const { t } = this.props;

    return (
      <div className={styles.coursesCard}>
        <div className={styles.coursesHeader}>
          <div className={styles.coursesHeaderLeft}>
            <img src="/Image/header/Courses.svg" alt="courses" className={styles.coursesHeaderIcon} />
            <Typography sx={{ fontWeight: 600, color: "#535353", fontSize: "15px", marginLeft: 1 }}>
              {t("dashboard.coursesCardHeader") || "Courses For You"}
            </Typography>
          </div>
          <MoreHorizIcon />
        </div>

        {loading && <div className={styles.emptyState}>Loading...</div>}
        {error && <div className={styles.emptyState} style={{ color: "#d32f2f" }}>{error}</div>}

        {!loading && !error && (
          <div className={styles.coursesList}>
            {courses.length ? (
              // show up to 4 items (you can change slice if you want)
              courses.slice(0, 4).map((course, idx) => {
                const title = course.name || course.title || "Course name";
                const thumbnail =
                  course.thumbnail ||
                  course.image ||
                  course.cover ||
                  "/Image/fallback-course.png";
                const ownerName = course.owner?.name || course.instructor || "";

                return (
                  <div key={idx} className={styles.courseItem}>
                    <div className={styles.courseLeft} style={{ minWidth: 0 }}>
                      <div className={styles.courseAvatar}>
                        <img src={thumbnail} alt={title} />
                      </div>

                      <div className={styles.courseInfo}>
                        <p className={styles.courseTitle} title={title} data-full={title}>
                          {title}
                        </p>
                        <p className={styles.courseMeta}>
                          {ownerName || (course.subtitle ? course.subtitle : "")}
                        </p>
                      </div>
                    </div>

                    <button className={styles.viewPill} onClick={() => this.handleView(course)}>
                      {t("common.view") || "View"}
                    </button>
                  </div>
                );
              })
            ) : (
              <div className={styles.emptyState}>{t("dashboard.noCourses") || "No courses right now"}</div>
            )}
          </div>
        )}

        <div
          className={styles.seeMore}
          onClick={() => this.props.history.push("/courses")}
          role="button"
          tabIndex={0}
          onKeyPress={() => this.props.history.push("/courses")}
        >
          <p className={styles.seeMoreText}>
            <span style={{ marginLeft: 5 }}>{t("dashboard.allCourses") || "See more"}</span>
          </p>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    // Expect RightSidebar to populate courses via getAllCourses(limit=5)
    coursesFromStore: state.courses?.publicCourses || state.courses?.homepageCourses || state.courses?.allcourses || null,
  };
}

// no mapDispatchToProps needed since CoursesCard doesn't dispatch now
export default withTranslation()(withRouter(connect(mapStateToProps)(CoursesCard)));
